var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-item"},[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.label)+"：")]),_c('el-tooltip',{attrs:{"content":_vm.content,"placement":"top","disabled":_vm.disabled}},[_c('p',{ref:"infoItemContentRef",class:[`ellipsis-${_vm.showLine}line`]},[_vm._v(_vm._s(_vm.content))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }